// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"2168e9de","453":"88b7b595"}[chunkId] + ".chunk.js";
};